<script>
/*eslint-disable */
import axios from "axios";
import { Line } from "vue-chartjs";
import root from "@/_helpers/roots";
let GetCovidListUrl = root.getCovidListUrl.link;
export default {
  extends: Line,
  props: ["Effective_Contact_Rate", "Recover_Inday"],
  data() {
    return {
      CovidData: "",
      CovidTime: [],
      CovidSusceptible: [],
      CovidInfected: [],
      CovidRecovered: []
    };
  },
  computed: {
  },
  mounted() {
      if (this.Effective_Contact_Rate != "" && this.Recover_Inday != "") {
        axios
          .get(
            GetCovidListUrl +
              "?transmission_rate=" +
              this.Effective_Contact_Rate +
              "&" +
              "R_0=" +
              this.Recover_Inday
          )
          .then(res => {
            this.CovidData = res.data.data;
            Object.keys(this.CovidData).map((key, index) => {
              this.CovidTime.push(this.CovidData[index][0]);
              this.CovidSusceptible.push(this.CovidData[index][1]);
              this.CovidInfected.push(this.CovidData[index][2]);
              this.CovidRecovered.push(this.CovidData[index][3]);
            });
            setTimeout(() => {
              if (this.CovidTime != undefined) {
                this.renderChart(
                  {
                    labels: this.CovidTime,
                    datasets: [
                      {
                        label: "Infected",
                        borderColor: "#FC2525",
                        borderWidth: 5,
                        data: this.CovidInfected,
                        radius: 0,
                        hoverRadius: 0,
                        fill: false
                      },
                      {
                        label: "Recovered",
                        borderColor: "#32CD32",
                        borderWidth: 5,
                        data: this.CovidRecovered,
                        radius: 0,
                        hoverRadius: 0,
                        fill: false
                      }
                    ]
                  },
                  {
                    responsive: true,
                    legend: {
                      display: true,
                      position: "top",
                      labels: {
                        fontSize: 14,
                        fontColor: "#ffffff"
                      }
                    },
                    tooltips: {
                      enabled: false
                    },
                    animation: {
                      duration: 1000
                    },
                    scales: {
                      yAxes: [
                        {
                          ticks: {
                            fontSize: 13
                          }
                        }
                      ],
                      xAxes: [
                        {
                          ticks: {
                            fontSize: 0
                          }
                        }
                      ]
                    },
                    maintainAspectRatio: false
                  }
                );
              }
            }, 100);
          });
      } else {
        axios.get(GetCovidListUrl).then(res => {
          this.CovidData = res.data.data;
          Object.keys(this.CovidData).map((key, index) => {
            this.CovidTime.push(this.CovidData[index][0]);
            this.CovidSusceptible.push(this.CovidData[index][1]);
            this.CovidInfected.push(this.CovidData[index][2]);
            this.CovidRecovered.push(this.CovidData[index][3]);
          });
          setTimeout(() => {
            if (this.CovidTime != undefined) {
              this.renderChart(
                {
                  labels: this.CovidTime,
                  datasets: [
                    {
                      label: "Infected",
                      borderColor: "#FC2525",
                      borderWidth: 5,
                      data: this.CovidInfected,
                      radius: 0,
                      hoverRadius: 0,
                      fill: false
                    },
                    {
                      label: "Recovered",
                      borderColor: "#32CD32",
                      borderWidth: 5,
                      data: this.CovidRecovered,
                      radius: 0,
                      hoverRadius: 0,
                      fill: false
                    }
                  ]
                },
                {
                  responsive: true,
                  legend: {
                    display: true,
                    position: "top",
                    labels: {
                      fontSize: 14,
                      fontColor: "#ffffff"
                    }
                  },
                  tooltips: {
                    enabled: false
                  },
                  animation: {
                    duration: 1000
                  },
                  scales: {
                    yAxes: [
                      {
                        ticks: {
                          fontSize: 13,
                          fontColor: "rgba(255,255,255,0.6)"
                        }
                      }
                    ],
                    xAxes: [
                      {
                        ticks: {
                          fontSize: 0,
                          fontColor: "rgba(255,255,255,0.6)"
                        }
                      }
                    ]
                  },
                  maintainAspectRatio: false
                }
              );
            }
          }, 10);
        });
      }
  },
  methods: {},
};
</script>